import Joi from '@hapi/joi'

export const  factoryEmployeeAttendanceReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    factoryID: Joi.number().invalid(0).required().label("Factory").messages({
        "any.invalid": `Please select valid Factory`,
        "any.required": `Factory required`
    }),
    routeID: Joi.number().invalid(0).required().label("Route").messages({
        "any.invalid": `Please select valid Route`,
        "any.required": `Route required`
    }),
    employeeNumber: Joi.string().max(50).allow("", null).label("employeeNumber").messages({
        "string.pattern.base": `Please enter valid Employee No`,
        "string.max": `Please enter {#limit} characters.`
    }),
    fromDate: Joi.string().invalid("").label("From Date"),
    toDate: Joi.string().invalid("").label("To Date"),
  
    
   
}